import { createSelector } from "reselect";
import { AppRootState } from "../../../lib/types/screen";

const selectHomePage = (state: AppRootState) => state.homePage;

export const retreivePopularProducts = createSelector(
  selectHomePage,
  (HomePage) => HomePage.popularProducts
);

export const retreiveNewProducts = createSelector(
  selectHomePage,
  (HomePage) => HomePage.newProducts
);

export const retreiveTopUsers = createSelector(
  selectHomePage,
  (HomePage) => HomePage.topUsers
);
